import { render, staticRenderFns } from "./form.vue?vue&type=template&id=740c7336&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=740c7336&prod&scoped=true&lang=scss"
import style1 from "./form.vue?vue&type=style&index=1&id=740c7336&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c7336",
  null
  
)

export default component.exports